import styled from "styled-components";
import { ModalHeader } from "reactstrap";

export default {
  ModalHeader: styled(ModalHeader)`
    .modal-title {
      flex-grow: 1;
      display: flex;
      justify-content: space-between;
    }
  `
};
